import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import rootReducer from './reducers';

const middlewares = [thunk];

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'],
};

const getConfig = () => {
  return process.env.REACT_APP_NODE_ENV !== "production" ?
    composeWithDevTools(applyMiddleware(...middlewares, logger)) :
    composeWithDevTools(applyMiddleware(...middlewares))
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = createStore(
  persistedReducer,
  {},
  getConfig()
);
const persistor = persistStore(store);

export default () => {
  return { store, persistor };
};
